import React, { PureComponent } from 'react'
import { Avatar, Modal } from 'antd'
import { timeFormat } from 'util/utils'
import Image from '../ImgWrapper'
import * as styles from './index.scss'

interface IProps {
  name: string
  avatar?: string
  time: string
  content: string
  pics?: string
  response?: string
  style?: React.CSSProperties
}

class Comment extends PureComponent<IProps> {
  state = {
    visible: false,
    previewImg: '',
  }

  handleCancel = () => this.setState({ visible: false })

  handleShowPic = idx => {
    const { pics } = this.props
    this.setState({
      previewImg: pics.split(',')[idx],
      visible: true,
    })
  }

  render() {
    const avatarRender = src => (
      <div className={styles.avatar}>
        <Avatar icon="user" size="large" src={src} />
      </div>
    )

    const timeRender = _time => (
      <div className={styles.commentBodyTime}>
        <span>{timeFormat(_time)}</span>
      </div>
    )

    const contentRender = _content => (
      <div className={styles.commentBodyContent}>
        <span>{_content}</span>
      </div>
    )

    const titleRender = _name => (
      <div className={styles.commentBodyTitle}>
        <span>{_name}</span>
      </div>
    )

    const responseRender = _content => (
      <div className={styles.response}>
        <div className={styles.responseInner}>
          <div className={styles.responseInnerTitle}>客服回复：</div>
          <div className={styles.responseInnerContent}>{_content}</div>
        </div>
      </div>
    )

    const picGroup = item => (
      <div className={styles.picGroup}>
        {item.split(',').map((iitem, iidx) => (
          <div
            className="item"
            key={`ss-${iidx}`}
            onClick={() => this.handleShowPic(iidx)}
          >
            <Image src={iitem} />
          </div>
        ))}
      </div>
    )

    const previewPic = url => (
      <Modal
        visible={this.state.visible}
        destroyOnClose
        footer={null}
        onCancel={this.handleCancel}
      >
        <img src={url} style={{ width: '100%' }} />
      </Modal>
    )

    const { avatar, name, content, response, pics, time, style } = this.props
    return (
      <div className={styles.comment} style={style}>
        <div className={styles.commentInner}>
          {avatarRender(avatar)}
          <div className={styles.commentBody}>
            {titleRender(name)}
            {timeRender(time)}
            {contentRender(content)}
            {pics && picGroup(pics)}
            {response && responseRender(response)}
          </div>
        </div>
        {previewPic(this.state.previewImg)}
      </div>
    )
  }
}

export default Comment
